export enum OperativeTypology {
  VOLO = 1,
  NAVE = 2,
  TRENO = 3,
  BUS = 4,
  AUTO = 5,
  SOLOLAND = 6
}
